import React from 'react'

import { useToggleState } from 'hooks/useToggleState'
import {
  EditableAssigneeTag,
  RequestedByTag,
  RequestedOnTag,
  WorkspaceTag
} from 'modules/requests/components/RequestMetaTags/RequestMetaTags'
import { DataAccessRequestAssignToModal } from 'modules/requests/data-access-requests/DataAccessRequestAssignToModal'
import { DataAccessRequestStatus as DataAccessRequestStatusBadge } from 'modules/requests/data-access-requests/components/DataAccessRequestStatus'
import { TagWrapper, TagsWrapper } from 'modules/resultsV2/Results.styles'
import { DataAccessRequestStatus } from 'services/data-access-requests/enums'
import type { DataAccessRequestVerificationDetail } from 'services/data-access-requests/types'

interface DataAccessRequestDetailsTagsProps {
  dataAccessRequest: DataAccessRequestVerificationDetail
}

export const DataAccessRequestDetailsTags = ({ dataAccessRequest }: DataAccessRequestDetailsTagsProps): JSX.Element => {
  const [isAssignToModalOpen, toggleAssignToModal] = useToggleState(false)

  return (
    <TagsWrapper>
      <TagWrapper>
        <DataAccessRequestStatusBadge
          reviewSubStatus={dataAccessRequest.reviewSubStatus}
          status={dataAccessRequest.status}
        />
      </TagWrapper>
      {!!dataAccessRequest.requestingUser?.email && <RequestedByTag email={dataAccessRequest.requestingUser.email} />}
      <RequestedOnTag at={dataAccessRequest.createdAt} />
      {!!dataAccessRequest.requesterContext.workspaceName && (
        <WorkspaceTag name={dataAccessRequest.requesterContext.workspaceName} />
      )}
      <EditableAssigneeTag
        email={dataAccessRequest.assignedTo?.email}
        isEditable={dataAccessRequest.status === DataAccessRequestStatus.PendingVerification}
        onEdit={toggleAssignToModal}
      />

      <DataAccessRequestAssignToModal
        requestId={dataAccessRequest._id}
        open={isAssignToModalOpen}
        onClose={toggleAssignToModal}
        assignedTo={dataAccessRequest.assignedTo?._id}
      />
    </TagsWrapper>
  )
}
